import { Button, Color, Icon, Space, Text } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

export interface CreateFolderButtonProps {
  onClick: () => void
}

export const CreateFolderButton = ({ onClick }: CreateFolderButtonProps) => {
  const { t } = useTranslation()

  return (
    <Button variant="text" onClick={onClick}>
      <Icon icon="plus" color={Color.Black} />
      <Space horizontal size="s4" />
      <Text variant="bodyMD" weight="semiBold">
        {t('documents.modal.move_item.button.create')}
      </Text>
    </Button>
  )
}
